module.exports = __webpack_public_path__ + "img/kr.e0c2b4f5.png";